export default __webpack_public_path__ + "static/media/calenderTick.438b8454.svg";